import React from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../core/hooks';
import { productSelector } from '../../features/product';
import { BodyLarge } from '../../fonts/typography/Typography';
import { DarkTextColor } from '../../fonts/typography/TypographyColors';
import useTranslate from '../../i18n/useTranslate';
import ProductAdderAdditionalCard from './ProductAdderAdditionalCard';
import ProductAdderFooterButtons from './ProductAdderFooterButtons';
import ProductAdderOngoingCartResume from './ProductAdderSummary';
import useSelectedProductId from '@src/hooks/useSelectedProductId';

const ProductAdderAdditionals = () => {
  const productId = useSelectedProductId();
  const { i18n } = useTranslate();
  const product = useAppSelector(productSelector(productId));
  const additionals = product?.additionals || [];

  return (
    <>
      <AdditionalsArea>
        <ProductAdderOngoingCartResume />
        <AdditionalsSubLabel>{i18n('adder_additionals')}</AdditionalsSubLabel>
        <AdditionalCards>
          {additionals.map((additional) => (
            <ProductAdderAdditionalCard key={additional.id} additional={additional} />
          ))}
        </AdditionalCards>
      </AdditionalsArea>
      <ProductAdderFooterButtons showValue />
    </>
  );
};

const AdditionalsArea = styled.div`
  position: relative;
  margin-bottom: 16px;
`;
const AdditionalCards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  margin-top: 8px;
`;

const AdditionalsSubLabel = styled.p`
  ${BodyLarge}
  ${DarkTextColor}
    margin-top: 24px;
`;

export default ProductAdderAdditionals;
